import { FC } from 'react'
import Card, { Props as CardProps } from 'src/components/CardMain'
import CardList from '@/components/module/CardList'
import { range } from '@/utils'
import { Pagination as PaginationProps, BreadCrumbs as BreadCrumbsProps } from 'src/types'
import BreadCrums from '@/components/Breadcrums'
import Pagination from '@/components/Pagination'
import { ArticlePageBase } from '@/route'

export type Props = {
  articles: CardProps[]
  page: PaginationProps
  breadcrumbs: BreadCrumbsProps
  title: string
  path?: (id: string) => string
}

const generatePath = (id: string) => {
  return `${ArticlePageBase}/${id}`
}

const Container: FC<Props> = ({ articles: as, page, breadcrumbs, title, path = generatePath }) => {
  const urls = range(1, page.total).map((num) => path(num.toString()))

  return (
    <main className="flex justify-center">
      <div className="card-container flex flex-col items-center">
        <BreadCrums items={breadcrumbs} />
        <div className="my-5 md:w-full md:text-left">
          <h2 className="text-2xl font-semibold text-secondary-700">{title}</h2>
        </div>
        <CardList>
          {as.map((a, idx) => {
            return (
              <Card
                key={`${a.title}-${idx}`}
                {...a}
              />
            )
          })}
        </CardList>
        <div className="mt-8">
          <Pagination urls={urls} currentPage={page.current} />
        </div>
      </div>
    </main>
  )
}

export default Container
